import IntroductionAnimation from './IntroductionAnimation';

export default IntroductionAnimation;
